import { createReducer, on } from '@ngrx/store';
import {
  Register,
  RegisterFailure,
  RegisterSuccess,
  getAgentPayrollSubmissionDetails,
  getAgentPayrollSubmissionDetailsFailure,
  getAgentPayrollSubmissionDetailsSuccess,
  getAgentPayrollSubmissions,
  getAgentPayrollSubmissionsFailure,
  getAgentPayrollSubmissionsSuccess,
  login,
  loginFailure,
  loginSuccess,
  logout,
  setSharedData,
} from './authentication.actions';
import { Pagination, PayrollSubmissions, User } from './auth.models';

export interface AuthenticationState {
  isLoggedIn: boolean;
  user: User | null;
  error: string | null;
  isLoading: boolean;
  payrollSubmissions: PayrollSubmissions[] | null;
  payrollSubmissionDetails: PayrollSubmissions | null;
  pagination: Pagination | null;
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  error: null,
  isLoading: false,
  payrollSubmissions: null,
  payrollSubmissionDetails: null,
  pagination: null,
};

export const authenticationReducer = createReducer(
  initialState,
  on(Register, (state) => ({ ...state, error: null })),
  on(RegisterSuccess, (state, { user }) => ({
    ...state,
    isLoggedIn: true,
    user,
    error: null,
  })),
  on(RegisterFailure, (state, { error }) => ({ ...state, error })),

  on(login, (state) => ({ ...state, error: null })),
  on(loginSuccess, (state) => ({ ...state, isLoggedIn: true, error: null })),
  on(loginFailure, (state, { error }) => ({ ...state, error })),
  on(logout, (state) => ({ ...state, user: null })),

  on(getAgentPayrollSubmissions, getAgentPayrollSubmissionDetails, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(
    getAgentPayrollSubmissionsFailure,
    getAgentPayrollSubmissionDetailsFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })
  ),

  on(getAgentPayrollSubmissionsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissions: data?.result ?? [],
  })),

  on(setSharedData, (state, { data }) => ({
    ...state,
    pagination: {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    },
  })),
  on(getAgentPayrollSubmissionDetailsSuccess, (state, { data }) => ({
    ...state,
    isLoading: false,
    payrollSubmissionDetails: data ?? null,
  }))
);
